/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import { createContext, useContext } from 'react';
export const GraphVisualizationContext = createContext(undefined);
/**
 * Hook to access the graph visualization context.
 *
 * This hook is used to implement custom UI components like buttons, panels, and controls
 * that need access to data and functionality from the graph visualization component.
 * @see {@link GraphVisualizationContextData}
 *
 * @returns The graph visualization context containing NVL instance, sidepanel, gestures, and graph data
 * @throws Error if used outside of a GraphVisualizationContext provider
 *
 * @example
 * ```tsx
 * const NodeLoggerButton = () => {
 *   const { selected } = useGraphVisualizationContext();
 *
 *   const handleClick = () => {
 *     console.log('Selected nodes:', selected.nodeIds);
 *   };
 *
 *   return (
 *     <button onClick={handleClick}>
 *       Log Selected Nodes ({selected.nodeIds.length})
 *     </button>
 *   );
 * };
 * ```
 * @alpha
 */
export const useGraphVisualizationContext = () => {
    const context = useContext(GraphVisualizationContext);
    if (!context) {
        throw new Error('useGraphVisualizationContext must be used within a GraphVisualizationContext');
    }
    return context;
};
//# sourceMappingURL=graph-visualization-context.js.map